import bcryptjs from 'bcryptjs';

export const compareHash = async (password,  hash) => {
    return bcryptjs.compareSync(password, hash);
}